import { PageBlueprint } from '@backstage/frontend-plugin-api';
import { Navigate } from 'react-router-dom';

export const rootRedirect = PageBlueprint.make({
  name: 'root-redirect',
  params: {
    path: '/',
    loader: async () => <Navigate to="/announcements" replace />,
  },
});
